export const disableAnalytics = () => {
    // Google Analytics
    window[`ga-disable-${process.env.REACT_APP_GA_TRACKING_ID}`] = true;
    // Google Tag Manager
    window[`ga-disable-${process.env.REACT_APP_GTM_TRACKING_ID}`] = true;
};
